import { EntityService } from '../../../../rest/entity.service';
import { JQueryHTTPClient } from '../../../../rest/JQueryHTTPClient';
import { Rest_logistics } from './rest_client_logistics';
import { Rest } from '../../../../rest/rest_client';
import { HttpClient} from '@angular/common/http';
import { AuthenticationService } from '../../../../core/services/authentication/authentication.service';
import { NotificationsService, Severity } from '../../../../services/notifications-service/notifications.service';
import { Injectable } from '@angular/core';


@Injectable()
export class AnalysisConfigurationService extends EntityService<Rest_logistics.AnalysisConfiguration> {
	client: Rest.RestApplicationClient;


 
	constructor(
		private jquery: JQueryHTTPClient,
		private http: HttpClient,
		private auth: AuthenticationService,
		private notificationsService: NotificationsService
	) {
		super();
		this.client_task = new Rest_logistics.RestApplicationClient(jquery);
	}

	getConfiguration(): Rest.RestResponse<Rest_logistics.AnalysisConfiguration> {
		return this.client_task.AnalysisConfiguration_getConfiguration();
	}

	create (configuration: Rest_logistics.AnalysisConfiguration): Rest.RestResponse<Rest_logistics.AnalysisConfiguration> {
		return this.client_task.AnalysisConfiguration_create(configuration);
	}


	
	
}
